export const StartClean = () => (
  <div className="signature-modal-vertial-center">
    <div>
      <p
        style={{
          transition: 'all 0.2s',
          fontWeight: 700,
          fontSize: 16
        }}
      >
        Start GP Connnect Sign
      </p>
    </div>
  </div>
)

export default StartClean
